import { render, staticRenderFns } from "./CustomersTable.vue?vue&type=template&id=37ca60a0&scoped=true&"
import script from "./CustomersTable.vue?vue&type=script&lang=js&"
export * from "./CustomersTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomersTable.vue?vue&type=style&index=0&id=37ca60a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ca60a0",
  null
  
)

export default component.exports